
/**
 * 屏蔽按键
 * @param {KeyboardEvent} e
 * @param {Array.<string>} keyCodes
 */
export const disableKeyCodes = (e, keyCodes) => {
  if (keyCodes.includes(e.key)) {
    e.preventDefault();
    e.stopPropagation();
  }
};
